module.exports = __webpack_public_path__ + "static/video 2-9c5835f0c57d2a22c05f345bb3423bea.jpg";